/**
 * 脚本触发器模板集合
 * 这些是用于展示给用户的示例代码，导出为字符串常量
 * 不作为可执行的代码文件
 */

export const scriptTriggerSimpleTemplate = `import { regTrigger } from "#/droid/java_js/fanfanlo/javajs/v1/project/store.java"
import { eventTypeExit, eventTypeComplete } from "#/droid/java_js/fanfanlo/javajs/v1/project/base/projectEventTypes.java"

let type = "fanfanlo/javajs/v1/project/components/triggers/script/simple"

onLibReady(() => {
  regTrigger(type, attach)
}, "fanfanlo/javajs/v1/project/components/triggers/script/simple")

function attach(that) {
  let domain = {};
  let logger = that.logger.subLogger('ScriptTrigger')

  function clean() {
    a11yModel.removeDomain(that);
    that.removeDomain(domain)
  }

  function onExitOrComplete(e) {
    clean();
  }

  let superOnRun = that.onRun;
  that.onRun = onRun.bind(that);

  function onRun() {
    superOnRun();
    addListener();
    check();
  }

  function addListener() {
    that.dispatcher.listenDomain(eventTypeExit, domain, onExitOrComplete);
    that.dispatcher.listenDomain(eventTypeComplete, domain, onExitOrComplete);
  }

  function onDataChange(event) {
    logger.log("data changed", event)
    check();
  }

  function check() {
    logger.log("check start", that.isRunnable)

    if (!that.isRunnable) {
      clean();
      return;
    }

    // 简单的脚本触发示例
    // 当前台包名等于配置的包名时，触发条件成立
    let packageName = a11yModel.lastFullScreenPackage;
    logger.log("current package", packageName, "target package", that.data.packageName)

    if (packageName === that.data.packageName) {
      that.dispatchConditionsOn({packageName})
    } else {
      that.dispatchConditionsOff({packageName})
    }
  }
}

export { type }`

export const scriptTriggerAdvancedTemplate = `import { regTrigger } from "#/droid/java_js/fanfanlo/javajs/v1/project/store.java"
import { eventTypeExit, eventTypeComplete } from "#/droid/java_js/fanfanlo/javajs/v1/project/base/projectEventTypes.java"
import { hideImeIfPackageOpened } from "#/droid/java_js/fanfanlo/javajs/v1/a11y/a11yUtils.java"

let type = "fanfanlo/javajs/v1/project/components/triggers/script/advanced"

onLibReady(() => {
  regTrigger(type, attach)
}, "fanfanlo/javajs/v1/project/components/triggers/script/advanced")

function attach(that) {
  let domain = {};
  let logger = that.logger.subLogger('ScriptTrigger')
  let isOn = false;

  function clean() {
    a11yModel.removeDomain(that);
    that.removeDomain(domain)
  }

  function onExitOrComplete(e) {
    logger.log("onExitOrComplete triggered")
    clean();
  }

  let superOnRun = that.onRun;
  that.onRun = onRun.bind(that);

  function onRun() {
    logger.log("onRun called")
    superOnRun();
    addListener();
    check();
  }

  function addListener() {
    logger.log("adding listeners")
    that.dispatcher.listenDomain(eventTypeExit, domain, onExitOrComplete);
    that.dispatcher.listenDomain(eventTypeComplete, domain, onExitOrComplete);
    a11yModel.listenDomainData(
      com.fanfanlo.droidlib.auto.service.accessibility.A11yModel.Companion.eventLastPackageChanged,
      domain,
      onPackageChange
    );
  }

  function onPackageChange(event) {
    logger.log("package changed", event)
    check();
  }

  function check() {
    logger.log("check start, isRunnable:", that.isRunnable)

    if (!that.isRunnable) {
      logger.log("script not runnable, cleaning up")
      clean();
      return;
    }

    // 高级脚本示例：包含状态管理和多条件判断
    let packageName = a11yModel.lastFullScreenPackage;
    let targetPackage = that.data.packageName;
    let hideIme = that.data.hideIme;

    logger.log("current package:", packageName)
    logger.log("target package:", targetPackage)
    logger.log("hideIme:", hideIme)

    // 检查是否需要隐藏输入法
    if (hideIme && hideImeIfPackageOpened(targetPackage)) {
      logger.log("ime is shown for target package, skipping")
      return;
    }

    // 状态转换管理
    let shouldBeOn = packageName === targetPackage;

    if (shouldBeOn && !isOn) {
      logger.log("transition to ON state")
      isOn = true;
      that.dispatchConditionsOn({packageName})
    } else if (!shouldBeOn && isOn) {
      logger.log("transition to OFF state")
      isOn = false;
      that.dispatchConditionsOff({packageName})
    }
  }

  let superOnExit = that.onExit;
  that.onExit = onExit.bind(that);

  function onExit() {
    logger.log("onExit called")
    superOnExit();
    a11yModel.removeDomain(that);
  }
}`

export const scriptTriggerFullTemplate = scriptTriggerAdvancedTemplate
